import React from "react";
import SelectField from "./SelectField";

const OPTIONS = [
  ["true", "Yes"],
  ["false", "No"],
];

export default function CustomSelectField(props) {
  return <SelectField {...props} options={props.options || OPTIONS} />;
}
